"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MinutesOptions;
(function (MinutesOptions) {
    MinutesOptions["EveryMinute"] = "everyMinute";
    MinutesOptions["SpecificMinute"] = "specificMinute";
    MinutesOptions["EveryMinuteBetween"] = "everyMinuteBetween";
})(MinutesOptions = exports.MinutesOptions || (exports.MinutesOptions = {}));
var HoursOptions;
(function (HoursOptions) {
    HoursOptions["EveryHour"] = "everyHour";
    HoursOptions["SpecificHour"] = "specificHour";
    HoursOptions["EveryHourBetween"] = "everyHourBetween";
})(HoursOptions = exports.HoursOptions || (exports.HoursOptions = {}));
var DaysOptions;
(function (DaysOptions) {
    DaysOptions["EveryDay"] = "everyDay";
    DaysOptions["SpecificDayOfWeek"] = "specificDayOfWeek";
    DaysOptions["SpecificDayOfMonth"] = "specificDayOfMonth";
    DaysOptions["EveryDayOfMonthBetween"] = "everyDayOfMonthBetween";
    DaysOptions["EveryDayOfWeekBetween"] = "everyDayOfWeekBetween";
})(DaysOptions = exports.DaysOptions || (exports.DaysOptions = {}));
var MonthOptions;
(function (MonthOptions) {
    MonthOptions["EveryMonth"] = "everyMonth";
    MonthOptions["SpecificMonth"] = "specificMonth";
    MonthOptions["EveryMonthBetween"] = "everyMonthBetween";
})(MonthOptions = exports.MonthOptions || (exports.MonthOptions = {}));
